import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiInterceptor } from 'src/app/core/interceptors/api/api.interceptor';
import { PwaSyncModel } from 'src/models/ts/pwa-sync.model';

@Injectable({
  providedIn: 'root'
})
export class PwaApiService {

  private http= inject(HttpClient);

  public sync(payload: PwaSyncModel) : Observable<PwaSyncModel> {
    return this.http.post<PwaSyncModel>('api/pwa/sync', payload);
  }

  public unsyncInstance(collectionId: number, instanceId: number, versionId: number): Observable<void> {
    return this.http.post<void>(`api/pwa/unsync/collection/${collectionId}/instance/${instanceId}/version/${versionId}`, null);
  }

  public unsyncFolder(payload: PwaSyncModel): Observable<void> {
    return this.http.post<void>(`api/pwa/unsync`, payload);
  }

  public offlineFile(request: {
    collectionsId: number,
    instancesId: number,
  }): Observable<any> {
    return this.http.get<any>(`api/pwa/sync/download/collection/${request.collectionsId}/instance/${request.instancesId}`);
  }

  public downloadOfflineFile(request: {
    collectionsId: number,
    instancesId: number,
  }, ignoreErrorHandlingHeader?: boolean): Observable<any> {
    //HttpParam can be passed to use another HttpClient with different interceptors (dodge stacked alert)
    let httpHeaders = new HttpHeaders();
    if (ignoreErrorHandlingHeader) {
      httpHeaders = ApiInterceptor.appendIgnoreErrorHandlingHeader(httpHeaders);
    }  
    return this.http.get<any>(`api/pwa/sync/download/collection/${request.collectionsId}/instance/${request.instancesId}`, {headers: httpHeaders, observe:'response'});
       
  }
}
